(function () {
  var Product = {
    init: function () {
      console.log('Init Product.js');
      
      if (this.isMobile() || window.innerWidth <= 900) {
        this.stickyProductNav();
      } else {
        this.initBenefits();
      }

      /* set the % in the benefits bar */
      let percElement = document.querySelector('.pdp-selector .pdp-card-first .js-pdp-sub-card-perc-off');
      if (document.querySelector('.pdp-selector .pdp-card-last') != null) {
        percElement = document.querySelector('.pdp-selector .pdp-card-last .js-pdp-sub-card-perc-off');
      }
      if (percElement == null || percElement.textContent == '0') {
        document.querySelector('.section-diatery-save-up__save').style.display = 'none';
      } else {
        document.querySelector('#max-discount').textContent = percElement.textContent + '%';
        /* let's track the changes */
        (new MutationObserver(this.onMutation))
        .observe(percElement, {
          childList: true,
          subtree: true
        });
      }

      /* Nutrition info popup handler */
      document.querySelectorAll('.view-nutrition').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          const nutritionModal = document.querySelector('.ingredients-popup');
          const nutritionInfoContainer = document.querySelector('.nutrition-info-container');
          const ingredientsOverlay = document.querySelector('.ingredients-overlay');
          ingredientsOverlay.addEventListener('click', function (e) {
            e.stopPropagation();
            ingredientsOverlay.style.display = 'none';
            nutritionModal.style.display = 'none';
          });
          ingredientsOverlay.style.display = 'block';
          nutritionModal.style.display = 'block';
          const nutritionCancel = document.querySelector('.ingredients-popup .icon-cancel-1');
          nutritionCancel.addEventListener('click', function (e) {
            e.stopPropagation();
            ingredientsOverlay.style.display = 'none';
            nutritionModal.style.display = 'none';
          });
        });
      });

      this.initProductCarousel();
      this.initTabsSections();
      this.initProductNav();
      this.initContentAccordion();
      this.openAccordion();   
      
      this.calculateRecommendReviewsPercent();
    }, // end init

    calculateRecommendReviewsPercent: function() {
      const yotpoReviewsParts = document.querySelectorAll('.yotpo-star-distribution-value');
      // wait a bit for reviews to load, in some case this runs before the html is complete
      let yoptoLoadTries = 0;
      const yotpoIntervalHandle = setInterval(
        () => {
          const yotpoReviewsParts = document.querySelectorAll('.yotpo-star-distribution-value');
          let reviewsTotal = 0;
          let recommendedTotal = 0;

          // only show info there are reviews
          if (yotpoReviewsParts.length <= 0) {
            yoptoLoadTries++;
            if (yoptoLoadTries > 5) {
              clearInterval(yotpoIntervalHandle);
            }
            return;
          }
          clearInterval(yotpoIntervalHandle);
          yotpoReviewsParts.forEach((yotpoReviewsPart) => {
            const singleReviewPart = parseInt(yotpoReviewsPart.innerHTML);
            reviewsTotal += singleReviewPart;

            // the 4 and 5 star reviews we care about and those are found in the last
            // two elments in the nodlist
            const distributionIndex = yotpoReviewsPart.closest('.yotpo-distribution-row').querySelector('.yotpo-star-distribution-index').textContent;
            if (distributionIndex === '4' || distributionIndex === '5') {
              recommendedTotal += singleReviewPart;
            }
          });

          const recommendedPercent = Math.trunc((recommendedTotal/reviewsTotal) * 100);
          const reviewsRecommendPercentLabelContainerEl = document.querySelector('.reviews-recommend-percent-label-container');
          const reviewsRecommendPercentValueContainerEl = document.querySelector('.reviews-recommend-percent-value-container');

          reviewsRecommendPercentLabelContainerEl.style.visibility = 'visible';
          reviewsRecommendPercentValueContainerEl.innerHTML = recommendedPercent;

          if (recommendedPercent < 86) {
            reviewsRecommendPercentLabelContainerEl.style.display = 'none';
          } else {
            reviewsRecommendPercentLabelContainerEl.style.display = 'block'; 
          } 
        },
        1000
      );
    },

    onMutation: function(mutations) {
      for (const mutation of mutations) {
        document.querySelector('#max-discount').textContent = mutation.target.textContent + '%';
      }
    },
    initTabsSections: function() {
      const sectionTabs = document.querySelectorAll('.tab-header, .product-nav li');
      const contentSections = document.querySelectorAll('.section-content__description, .section-content__science, .section-content__ingredients, .section-reviews');
      const productNavs = document.querySelectorAll('.product-nav a.product-nav-tab');
      document.querySelectorAll('.tab-header').forEach(function (el) {
        //el.addEventListener('click', switchTab(el));
        el.addEventListener('click', function () {
          //console.log(el);
          //switchTab(el);
          if (!el.classList.contains('active')) {
            sectionTabs.forEach(function (el) {
              //console.log(el);
              el.classList.remove('active');
            });
            contentSections.forEach(function (el) {
              el.classList.remove('active');
            }); 
            productNavs.forEach(function (el) {
              el.classList.remove('active');
            }); 
            el.classList.add('active');
            if (el.dataset.targetContent == '.section-reviews') {
              Product.scrollTo(el, 500);
            }                        
            document.querySelectorAll(el.dataset.targetContent).forEach(function (el) {
              el.classList.add('active');
            });
          }
        });        
      });      
    },
    initProductNav: function() {
      const productNavs = document.querySelectorAll('.product-nav a.product-nav-tab');
      document.querySelectorAll('.product-nav li').forEach(function (el) {
        el.addEventListener('click', function () {
          Product.scrollTo(document.querySelector(el.dataset.targetContent), 300);          
        });
      });
    },    
    initBenefits: function() {
      document.body.addEventListener('touchmove', onScroll); // for mobile
      document.body.addEventListener('scroll', onScroll);
      window.addEventListener('wheel', onScroll);
      var navTop = document.querySelector('.section-diatery-save-up').offsetTop;
      let self = this;
      function onScroll() {
        if (navTop < window.pageYOffset) {
          document.querySelector('.js--benefits').classList.add('fixed');
          if (!self.isMobile()) {
            // .toolbar
            //document.querySelector('.header-fixed-container .focus-banner').style.visibility = 'hidden';
            //document.querySelector('.header-fixed-container .focus-banner').style.height = '0px';
            document.querySelector('.header-section').classList.add('header-fixed-container');
            document.querySelector('.section-diatery-save-up').style.marginTop = '0px';
            document.querySelector('.section-diatery-save-up').style.marginBottom = '0px';
            document.querySelector('#HeaderWrapper').style.display = 'none';
          } else {
            //document.querySelector('#HeaderWrapper').style.marginTop = '100px'; 
          }
        } else {
          document.querySelector('.js--benefits').classList.remove('fixed');
          document.querySelector('.header-section').classList.remove('header-fixed-container');          
          if (!self.isMobile()) {
            /*
            window.scale.sq.css('.header-fixed-container .focus-banner', {
              visibility: 'visible',
              height: 'auto',
            });
            */
            document.querySelector('.section-diatery-save-up').style.marginTop = '35px';
            document.querySelector('.section-diatery-save-up').style.marginBottom = '50px';
            document.querySelector('#HeaderWrapper').style.display = 'block'
          }
          // fixes critical navigation bug with BF sticky
          var bfSticky = document.querySelector('#bfij-banner');
          if (!bfSticky) {
            //window.scale.sq.css('#header', { marginTop: '0' });
          }
        }
      }
      window.addEventListener(
        'resize',
        function () {
          navTop = document.querySelector('.section-diatery-save-up').offsetTop;
        },
        true
      );
    },
    stickyProductNav: function() {
      var navTop = 1900;

      function highlightNavigation() {
        // get the current vertical position of the scroll bar
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var section = document.querySelectorAll('.section');
        var sections = {};

        Array.prototype.forEach.call(section, function (e) {
          sections[e.name] = e.offsetTop;
        });

        /* offset isn't working, manually set them */
        sections['science'] = 1900;
        sections['ingredients'] = 2850;
        sections['reviews'] = 3450;

        for (i in sections) {
          if (scrollPosition + 40 >= sections[i]) {
            document.querySelector('.active').setAttribute('class', ' ');
            document
              .querySelector('.product-nav a[href*=' + i + ']')
              .setAttribute('class', 'active');
          }
        }
      }
      function onScroll() {
        var ypos = window.pageYOffset;
        if (navTop < ypos) {
          document.querySelector('.product-nav').classList.add('fixed');
          document.querySelector('#HeaderWrapper').style.display = 'none';
          //document.querySelector('.header-fixed-container .focus-banner').style.visibility = 'hidden';
          //document.querySelector('.header-fixed-container .focus-banner').style.height = '0px';
        } else {
          document.querySelector('.product-nav').classList.remove('fixed');
          document.querySelector('#HeaderWrapper').style.display = 'block';
          //document.querySelector('.header-fixed-container .focus-banner').style.visibility = 'visable';
          //document.querySelector('.header-fixed-container .focus-banner').style.height = 'auto';
        }
        highlightNavigation();
      }

      window.addEventListener(
        'resize',
        function () {
          navTop = document.querySelector('.product-nav').offsetTop;
        },
        true
      );

      document.body.addEventListener('touchmove', onScroll); // for mobile
      window.addEventListener('wheel', onScroll);
      window.addEventListener('scroll', onScroll);
    },    
    initProductCarousel() {
      var thumbnailsSelector = '.js--section-product__thumbnails';
      var carouselGlide = new Glide('.js--section-product__slider', {
        type: 'carousel',
        startAt: 0,
        perView: 1,
      });
      var thumbnailGlide = new Glide(thumbnailsSelector, {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        focusAt: 0,
        gap: 20,
      });
    
      carouselGlide.on('run.after', () => {
        this.initZoom('.js--section-product__slider-item.glide__slide--active');
      });
    
      carouselGlide.on('run', function () {
        if (carouselGlide.index == thumbnailGlide.index) {
          return;
        }
        thumbnailGlide.go('=' + carouselGlide.index);
      });
    
      carouselGlide.mount();
    
      this.initZoom('.js--section-product__slider-item');
    
      var setActiveThumbnail = function (selectedIndex) {
        var activeThumbnails = document.querySelectorAll('.section-product__thumb-item--active');
        for (var i = 0; i < activeThumbnails.length; i++) {
          activeThumbnails[i].classList.remove('section-product__thumb-item--active');
        }
        var selectedThumbnails = document.querySelectorAll(
          thumbnailsSelector +
            ' ' +
            '.section-product__thumb-item[data-img-number="' +
            selectedIndex +
            '"]'
        );
        for (var i = 0; i < selectedThumbnails.length; i++) {
          selectedThumbnails[i].classList.add('section-product__thumb-item--active');
        }
      };
    
      var didUpdateThumbnailSettings = false;
      thumbnailGlide.on('build.after', function () {
        var thumbnailContainerElements = document.querySelectorAll('.section-product__thumb-item');
        for (var i = 0; i < thumbnailContainerElements.length; i++) {
          thumbnailContainerElements[i].addEventListener('click', function (e) {
            thumbnailGlide.go('=' + this.dataset.imgNumber);
          });
        }
        setActiveThumbnail(thumbnailGlide.index);
        if (!didUpdateThumbnailSettings) {
          setTimeout(function () {
            thumbnailGlide.update(thumbnailGlide.settings);
            didUpdateThumbnailSettings = true;
          }, 300);
        }
      });
    
      thumbnailGlide.on('run', function () {
        setActiveThumbnail(thumbnailGlide.index);
        if (carouselGlide.index == thumbnailGlide.index) {
          return;
        }
        carouselGlide.go('=' + thumbnailGlide.index);
      });
    
      thumbnailGlide.mount();
    
      this.addEventListener(
        'click',
        thumbnailsSelector + ' .section-product__slider-arrow-left',
        function () {
          thumbnailGlide.go('<');
        }
      );
      this.addEventListener(
        'click',
        thumbnailsSelector + ' .section-product__slider-arrow-right',
        function () {
          thumbnailGlide.go('>');
        }
      );
    },    
    initZoom: function (imgSelector) {
      if (this.isMobile()) {
        return;
      }
      document.querySelectorAll(imgSelector).forEach(function (galleryImg) {
        const img = galleryImg.querySelector('img');
        Product.imageLoaded(img, function () {
          if (img.naturalWidth >= 800) {
            new ImageZoom(galleryImg, {
              fillContainer: true,
              zoomPosition: 'original',
              gap: 20,
            });
          }
        });
      });
    }, 
    initContentAccordion: function () {
      var acc = document.getElementsByClassName('js--title');
      var i;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function () {
          this.classList.toggle('active');
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = '100%';
          }
        });
      }
    },    
    openAccordion: function () {
      const accordionItems = document.querySelectorAll('.section-content__accordion details');
      for (let i = 0; i < accordionItems.length; i++) {
        accordionItems[i].removeAttribute('open');
        accordionItems[i].addEventListener('click', function (e) {
          e.preventDefault();
          if (this.hasAttribute('open')) {
            this.removeAttribute('open');
            return;
          }
          const openAccordions = document.querySelectorAll(
            '.section-content__accordion details[open]'
          );
          for (let j = 0; j < openAccordions.length; j++) {
            openAccordions[j].removeAttribute('open');
          }
          this.setAttribute('open', '');
        });
      }
    },    
    imageLoaded: function(targetElements, callback) {
      //let self = this;
      this.forEachElement(targetElements, function (image) {
        if (image.tagName !== 'IMG') {
          return false;
        }
        if (image.complete) {
          callback();
        } else {
          image.addEventListener('load', callback);
        }
      });
    },    
    getElementsFromVar: function (elementsTarget, firstItem) {
      if (!elementsTarget) {
        return firstItem ? undefined : [];
      }
      if (typeof elementsTarget === 'string') {
        elementsTarget = document.querySelectorAll(elementsTarget);
      }
      if (firstItem) {
        return elementsTarget instanceof HTMLElement ? elementsTarget : elementsTarget[0];
      } else {
        return elementsTarget instanceof HTMLElement ? [elementsTarget] : elementsTarget;
      }
    },    
    forEachElement: function (targetElements, callback) {
      targetElements = this.getElementsFromVar(targetElements, false);
      for (let i = 0; i < targetElements.length; i++) {
        callback(targetElements[i], i);
      }
    },
    addEventListener: function (eventName, targetElements, callback, callbackName) {
      targetElements = this.getElementsFromVar(targetElements, false);
      try {
        for (let i = 0; i < targetElements.length; i++) {
          if (!callbackName) {
            callbackName = 'default_' + eventName + '_' + (new Date()).getTime();
          }
          if (!('sqEventListeners' in targetElements[i])) {
            targetElements[i].sqEventListeners = {};
          }
          if (!(eventName in targetElements[i].sqEventListeners)) {
            targetElements[i].sqEventListeners[eventName] = [];
          }
          // @todo remove the old listener?
          // if (targetElements[i].sqEventListeners[eventName].length > 0) {
          //   this.removeEventListener(eventName, targetElements[i], callbackName);
          // }
          targetElements[i].sqEventListeners[eventName].push({
            callbackName: callbackName,
            handler: callback,
          });
          targetElements[i].addEventListener(eventName, callback);
        }
      } catch (err) {
        console.error(err);
      }
    },
    offset: function (targetElements) {
      /** @type {HTMLElement|undefined} */
      var targetElem = this.getElementsFromVar(targetElements, true);
      if (targetElem == null) {
        return null;
      }
      const elementRect = targetElem.getBoundingClientRect();
      return {
        top: elementRect.top + document.body.scrollTop,
        left: elementRect.left + document.body.scrollLeft,
      };
    },    
    scrollTo: function(target, animationDuration, extraOffset) {
      const startYOffset = window.pageYOffset;
      if (typeof target != 'number') {
        const offset = this.offset(target);
        if (offset === null) {
          return;
        }
        target = offset.top + startYOffset;
      }
      if (extraOffset) {
        target += extraOffset;
      }
      const distanceToTarget = target - startYOffset;
      if (distanceToTarget === 0) {
        return;
      }
      if (animationDuration == null) {
        animationDuration = 500;
      }
      var startTime = null;
      window.requestAnimationFrame(function scrollStep(currentTime) {
        if (startTime === null) {
          startTime = currentTime;
        }
        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= animationDuration) {
          this.scrollTo(0, target);
          return;
        }
        const amountToScroll = distanceToTarget * elapsedTime / animationDuration;
        this.scrollTo(0, startYOffset + amountToScroll);
        window.requestAnimationFrame(scrollStep);
      });
    },    
    isMobile: function() {
      return window.outerWidth <= 768;
    },
    
  };// end Product

  if(performance.navigation.type == 2) {
    location.reload(true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    Product.init();
  });
})();  

//window.product = Product;
